<template>
  <div id="container">
    <div class="headerLogin">
      <div>
        <img class="img" src="../../../static/image/login/logo.png" alt="" />
        <span class="span">欢迎登录</span>
      </div>
    </div>
    <!--     style="background-image: url('../../../static/image/login/back.png')" -->
    <div class="content">
      <img class="back-img" src="../../../static/image/login/back.png" alt="" />
      <div class="contentUser">
        <div class="contentLeft">
          <img class="imgs" src="../../../static/image/login/loginimg.png" alt="" />
        </div>
        <div class="contentRight">
          <div class="userlogin">用户登录</div>
          <div class="information">
            <!-- 密码登录 -->
            <div v-if="aaa == true">
              <div class="topone">
                <img class="nameImg" src="../../../static/image/login/姓名.png" alt="" />
                <input class="nameInput" type="text" placeholder="登录号码" v-model="account1" />
              </div>
              <div class="line"></div>
              <div >
                <img class="wordImg" src="../../../static/image/login/密码.png" alt="" />
                <input class="wordInput" :type="pwdType" placeholder="请输入密码" v-model="password1" />
                <img src="../../../static/image/canNotSee.png" alt="" v-if="pwdType=='password'" @click="changeType3()" style="width: 30px;
    position: relative;top: 6px;left: 10px">
                <img src="../../../static/image/canSeeNew.png" alt="" v-else  @click="changeType4()" style="width: 30px;
    position: relative;top: 6px;left: 10px">
              </div>
              <div class="line"></div>
              <div class="registerForget">
                <span class="register" @click="register">注册账号</span>
                <span class="forget" @click="forgetPassword">忘记密码?</span>
              </div>
              <div class="btn">
                <button class="buttons" @click="accountPasswordLogin">
                  登录
                </button>
              </div>
              <div class="code2" @click="codeLoginClick">短信验证码登录</div>
            </div>

            <!-- 验证码登录 -->
            <div v-if="yanzhenCode == true">
              <div class="topone">
                <img class="nameImg" src="../../../static/image/login/姓名.png" alt="" />
                <input class="nameInput" maxlength="11" placeholder="请输入手机号" v-model="phoneNum" />
                <button class="yzbuton" v-if="codeSuccess">
                  {{ timeCount }}s后重新发
                </button>
                <button class="yzbuton" v-else @click="getCode">
                  发送验证码
                </button>
              </div>
              <div class="line"></div>
              <div>
                <img class="wordImg" src="../../../static/image/login/组 2421.png" alt="" />
                <input class="wordInput" type="number" placeholder="请输入验证码" maxlength="6" v-model="codeNum" />
              </div>
              <div class="line"></div>
              <div class="registerForget">
                <span class="register" @click="register">注册账号</span>
                <span class="forget" @click="forgetPassword">忘记密码?</span>
              </div>
              <div class="btn">
                <button class="buttons" @click="loginCodeFn">登录</button>
              </div>
              <div class="code" @click="passLogin">密码登录</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部展示区域 -->
    <div class="footerDiv">
      <BottomRegion class="footerForm" ref="bottomForm"></BottomRegion>
    </div>
  </div>
</template>

<script>
  import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示

  export default {
    name: "login",
    components: {
      BottomRegion,
    },
    data() {
      return {
        pwdType:'password',
        aaa: true,
        yanzhenCode: false,
        userName: "",
        password: "",
        account1: "",
        password1: "",
        //验证码登录的手机号
        phoneNum: "",
        codeNum: "",
        codeSuccess: false,
        timeCount: 60,
        returnUrl:""
      };
    },
    created() {
      // this.returnUrl = typeof(this.$route.query.returnUrl)!='undefined'?this.$route.query.returnUrl:"";
      this.returnUrl = sessionStorage.getItem('returnUrl')
      // console.log(this.$route.query.returnUrl)
    },
    methods: {
      changeType3(){
        this.pwdType = 'text'
      },
      changeType4(){
        this.pwdType = 'password'
      },
      //验证码登录
      async loginCodeFn() {
        console.log(this.phoneNum)
        console.log(this.codeNum)
        if (!this.phoneNum || !this.codeNum) {
          return false;
        }
        try {
          let data = {
            phone: this.phoneNum,
            captcha: this.codeNum,
            loginType: 2,
            // openid:openid
          };
          const res = await this.$http.accountPasswordLogin(data);
          console.log(res);
          if (res.code == 200) {
            let token = res.result.token;
            let userInfo = res.result.userInfo;
            localStorage.setItem("token", token);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
			// console.log(this.returnUrl,this.returnUrl.indexOf('taskDetail'))
            if(this.returnUrl != "" && this.returnUrl != null){
				// console.log(this.returnUrl,this.returnUrl.indexOf(taskDetail))
				if(this.returnUrl.indexOf('taskDetail')!=-1){
					this.$router.push({
					  path: this.returnUrl
					})
				
				}else{
					this.$router.push({
					  path: "/home/home"
					})
				}
             
            }else{
              this.$router.push({
                path: "/home/home"
              });
            }

          } else {
            this.$message(res.message);
          }
        } catch (e) {
          throw e;
        }
      },
      //发送验证码
    async getCode() {
        if (!this.phoneNum || this.codeSuccess) {
          return false;
        }
        if (!/^1[3|4|5|8|7|6|9][0-9]\d{8}$/.test(this.phoneNum)) {
          this.$message("请输入正确手机号码");
          return false;
        }
        let data = {
          phone: this.phoneNum,
          smsMode: 2,
        };
        try {
          const res = await this.$http.designerSms(data);
          console.log(res);
          if (res.code == 200) {
            this.$message({
              message: "验证码已发送",
              type: "success",
            });
            this.codeSuccess = true;
            this.timeCount = 60;
            let timer = setInterval(() => {
              if (this.timeCount <= 0) {
                clearInterval(timer);
                this.codeSuccess = true;
                this.timeCount = 60;
              } else {
                this.timeCount--;
              }
            }, 1000);
          } else {
            this.$message(res.message);
          }
        } catch (e) {
          throw e;
        }
    },
	async accountPasswordLogin() {
        if (!this.account1) {
          this.$message("请输入账号");
          return false;
        }
        if (!this.password1) {
          this.$message("请输入密码");
          return false;
        }
        let data = {
          phone: this.account1,
          password: this.password1,
          loginType: 1,
        };
        try {
          const res = await this.$http.accountPasswordLogin(data);
          console.log(res);
          if (res.code == 200) {
            let token = res.result.token;
            let userInfo = res.result.userInfo;
            localStorage.setItem("token", token);
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
			console.log(this.returnUrl)
           if(this.returnUrl != "" && this.returnUrl != null){
           	// console.log(this.returnUrl,this.returnUrl.indexOf('taskDetail'))
           	if(this.returnUrl.indexOf('taskDetail')!=-1){
           		this.$router.push({
           		  path: this.returnUrl
           		})
           	
           	}else{
           		this.$router.push({
           		  path: "/home/home"
           		})
           	}
            
           }else{
             this.$router.push({
               path: "/home/home"
             });
           }
          } else {
            this.$message(res.message);
          }
        } catch (e) {
          throw e;
        }
      },
      codeLoginClick() {
        this.aaa = false;
        this.yanzhenCode = true;
      },
      passLogin() {
        this.yanzhenCode = false;
        this.aaa = true;
      },
      register() {
        this.$router.push({
          name: "register",
        });
        console.log("llll");
      },
      forgetPassword() {
        this.$router.push({
          name: "forgetPassword"
        });
        // console.log("oooo");
      },
      login() {
        // console.log("login");·
      },
      messageCode() {
        this.$router.push({
          name: "loginNumber"
        });
        // console.log("messageCode");
      },
    },
  };
</script>

<style lang='less' scoped>
  #container {
    width: 100%;
    height: 100%;

    .headerLogin {
      width: 100%;
      height: 100px;

      /* // background: red; */
      .img {
        margin-left: 379px;
        margin-top: 24px;
      }

      .span {
        position: relative;
        top: -12px;
        margin-left: 27px;
        width: 104px;
        height: 30px;
        font-size: 25px;
        font-weight: 500;
        color: #333333;
        cursor: pointer;
      }
    }

    .content {
      width: 100%;
      height: 784px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      /* // background: red; */
      display: flex;
      justify-content: center;
      position: relative;
    }

    .back-img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    .contentUser {
      display: inline-block;
      width: 777px;
      height: 486px;
      /* // background: blue; */
      margin-top: 85px;
      /* margin-left: 572px; */
      z-index: 1;
      /*opacity: 0.6;*/

      .contentLeft {
        float: left;
        width: 361px;
        height: 486px;
        .imgs {
          width: 361px;
            height: 486px;
          /* margin-left: 35px; */
        }
      }

      .contentRight {
        background-color: #ffffff;
        float: right;
        width: 416px;
        height: 486px;

         /* background-color: cadetblue; */
        .userlogin {
          margin-left: 144px;
          margin-top: 100px;
          width: 104px;
          height: 36px;
          font-size: 25px;
          font-weight: bold;
          line-height: 31px;
          color: #333;
        }

        .information {
          /* background-color: red; */
          /* margin: 0 66px; */
          .topone {
            margin-top: 45px;
          }

          .bbb {
            margin-top: ;
          }

          .code2 {
            cursor: pointer;
            margin-left: 152px;
            margin-top: 12px;
            font-size: 13px;
            color: #3A3A3A;
            font-weight: 500;
          }

          .line {
            height: 2px;
            /* // background-color: chartreuse; */
            width: 268px;
            height: 0px;
            border-bottom: 1px solid #f2f6fc;
            opacity: 1;
            margin-left: 66px;
            margin-top: 16px;
          }

          .nameImg {
            margin-left: 74px;
            position: relative;
            top: 10px;
          }

          .nameInput {
            border: none;
            height: 20px;
            position: relative;
            top: 6px;
            left: 10px;
          }

          .yzbuton {
            position: relative;
            left: -35px;
            top: 4px;
            display: inline;
            width: 90px;
            height: 28px;
            background: #ffffff;
            border: 1px solid #dfb876;
            color: #dfb876;
            font-size: 12px;
            border-radius: 5px;
          }

          .yzbuton:focus {
            // border: none;
            outline: none;
          }

          .nameInput:focus {
            border: none;
            outline: none;
          }

          .wordImg {
            margin-left: 74px;
            margin-top: 10px;
            position: relative;
            top: 10px;
          }

          .wordInput {
            border: none;
            height: 20px;
            position: relative;
            top: 6px;
            left: 10px;
          }

          .wordInput:focus {
            border: none;
            outline: none;
          }

          .registerForget {

            .register {
              margin-left: 65px;
              display: inline-block;
              margin-top: 14px;
              font-size: 13px;
              color: #3A3A3A;
            }

            .forget {
              cursor: pointer;
              display: inline-block;
              margin-left: 146px;
              font-size: 13px;
              color: #3A3A3A;
            }
          }

          .btn {
            .buttons {
              background: #dfb876;
              width: 268px;
              height: 40px;
              border-radius: 20px;
              margin-left: 65px;
              margin-top: 24px;
              border: none;
              outline: none;
              color: #fff;
              font-size: 15px;
            }
          }

          .code {
            cursor: pointer;
            margin-left: 172px;
            margin-top: 12px;
            font-size: 13px;
            color: #3a3a3a;
          }
        }
      }
    }

    .footerDiv {
      position: relative;

      .footerForm {
        position: absolute;
        bottom: -90px;
      }
    }
  }

  input:-internal-autofill-selected {
    -webkit-text-fill-color: #303133 !important;
    transition: background-color 5000s ease-in-out 0s !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue